import { supabase } from "../supabase-client";

export const markChallengeCompleted = async (
  userId: string,
  challengeId: string,
  points?: number,
  beatCrowd?: boolean
): Promise<boolean> => {
  try {
    const { data: existing, error: checkError } = await supabase
      .from("completed_challenges")
      .select("id")
      .eq("user_id", userId)
      .eq("challenge_id", challengeId);

    if (checkError) {
      console.error("Error checking existing challenge:", checkError);
      return false;
    }

    if (existing && existing.length > 0) {
      console.log("Challenge already completed:", challengeId);
      return true;
    }

    const insertData: any = {
      user_id: userId,
      challenge_id: challengeId,
    };

    if (points !== undefined) {
      insertData.points_earned = points;
    }
    if (beatCrowd !== undefined) {
      insertData.beat_crowd = beatCrowd;
    }

    const { error } = await supabase
      .from("completed_challenges")
      .insert(insertData);

    if (error) {
      console.error("Error marking challenge completed:", error);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Unexpected error in markChallengeCompleted:", error);
    return false;
  }
};
